export default "/static/e3ade8b3d31ced83.mp4"